import { render, staticRenderFns } from "./PageStaffCreate.vue?vue&type=template&id=0a9c1b96&scoped=true&"
import script from "./PageStaffCreate.vue?vue&type=script&lang=ts&"
export * from "./PageStaffCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PageStaffCreate.vue?vue&type=style&index=0&id=0a9c1b96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c1b96",
  null
  
)

export default component.exports